import React from 'react'
import { Card } from './Card'
import { Checkout as ReusableCheckout } from '../../GJKit/Checkout'
import { ContainerWithTransparentScroll } from './style'

export const Checkout = () => {
  return (
    <Card>
      <ContainerWithTransparentScroll>
        <ReusableCheckout />
      </ContainerWithTransparentScroll>
    </Card>
  )
}
